import { describeFreshness } from '../ceoCockpitModel'
import type { CeoCockpitResponse } from '../ceoCockpitTypes'
import { CeoDemoCompanyStrip } from './CeoDemoCompanyStrip'

export type CeoMastheadProps = {
  payload: CeoCockpitResponse
  appApi?: import('../../../../../data/ServerApiClient').ServerApiClient | null
  historical?: boolean
}

/**
 * Company, freshness, and nothing else.
 *
 * The masthead used to carry a headline drawn from this morning's top
 * incident. That sentence is now the first card on Today, where it belongs —
 * and printing it above the tabs meant every rhythm was crowned with a claim
 * about a different one: "Maple Row labor % is over target" sat above This
 * month, whose only item was a margin outlier from May. The cards say what is
 * happening; this says whose books they are and how current.
 */
export function CeoMasthead({ payload, appApi, historical = false }: CeoMastheadProps) {
  const freshness = describeFreshness(payload.freshness, payload.as_of_date)
  const historicalSource = payload.status.review_mode === 'current_books_as_of'
    ? 'Current books'
    : 'Retained snapshot'
  const historicalLine = `${historicalSource} · Through ${formatSnapshotDate(payload.as_of_date)}`
  return (
    <header className="ceo-masthead rise" id="ceo-masthead">
      <p className="ceo-eyebrow">CEO COCKPIT · {payload.company.name}</p>
      <p className={`ceo-trust ${freshness.stale ? 'is-stale' : ''}`} title={freshness.reasons.join(' · ') || undefined}>
        <span className="ceo-trust-dot" aria-hidden="true" />
        {historical ? historicalLine : freshness.line}
      </p>
      <CeoDemoCompanyStrip currentSlug={payload.company.demo_slug || null} appApi={appApi} />
    </header>
  )
}

function formatSnapshotDate(iso: string): string {
  const parsed = new Date(`${iso}T00:00:00Z`)
  if (Number.isNaN(parsed.getTime())) return iso
  return parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}
